const permissionTypes = {
    APP_MANAGER: 'AppManager',
    APP_MANAGER_APP_CREATE: 'AppManager.Apps.Create',
    APP_MANAGER_APP_REMOVE: 'AppManager.Apps.Delete',
    APP_MANAGER_APP_UPDATE: 'AppManager.Apps.Update',
    ASSETS_MANAGER: 'AssetsManagers',
    ASSETS_MANAGER_VOD : 'AssetsManagers.Vod',
    ASSETS_MANAGER_LIVE : 'AssetsManagers.Live',
    ASSETS_MANAGER_LIVE_SCHEDULE : 'AssetsManagers.LiveSchedule',
    APP_MANAGER_SPONSOR: 'AssetsManagers.sponsors',
    APP_MANAGER_SPONSOR_CREATE: 'AssetsManagers.sponsors.create',
    APP_MANAGER_SPONSOR_UPDATE: 'AssetsManagers.sponsors.update',
    APP_MANAGER_SPONSOR_REMOVE: 'AssetsManagers.sponsors.remove',
    SCOREBOARD: 'Scoreboard',
    XTADIUM: 'Xtadium',
    ADMIN: 'Admin',
    ADMIN_ORGANIZATION: 'Admin.Organization',
    ADMIN_USER: 'Admin.User',
    ADMIN_ROLE: 'Admin.Role',
    ADMIN_LIVEDEPLOYMENT: 'Admin.LiveDeployment',
    ADMIN_LIVESETTING: 'Admin.LiveSetting',
    ADMIN_TAGMANAGER:'Admin.TagManager',
    DEBUG:'Debug',
    CLIENT_PORTAL: 'ClientPortal',
    BLACK_LABEL:'BlackLabel',
    BLACK_LABEL_CONFIGS:'BlackLabel.ManageConfigs',
    BLACK_LABEL_CONFIGS_UPDATE:'BlackLabel.ManageConfigs.Update',
    BLACK_LABEL_CONFIGS_CREATE:'BlackLabel.ManageConfigs.Create',
    BLACK_LABEL_CONFIGS_DELETE:'BlackLabel.ManageConfigs.Delete'
}

export default permissionTypes;